import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { BellRing, X } from 'lucide-react';
import { playChime } from '../../lib/sound';

/** Eventos del viaje que merecen un aviso visible y con sonido para el cliente. */
export const CUSTOMER_ALERT_TYPES = new Set(['quote.received', 'booking.confirmed', 'ride.driver_on_the_way', 'ride.driver_arrived', 'ride.started', 'ride.completed', 'ride_request.info_requested', 'ride.destination_changed', 'ride.incident', 'booking.cancelled']);
export const CUSTOMER_EVENT = 'tcrd:customer-event';
export const announceCustomerEvent = (e: { title: string; body?: string; url?: string }) => window.dispatchEvent(new CustomEvent(CUSTOMER_EVENT, { detail: e }));

const SHOW_MS = 10_000;

/** Banner superior con sonido mientras el cliente tiene la página abierta (no requiere instalar nada). */
export function CustomerEventAlert() {
  const history = useHistory();
  const [ev, setEv] = useState<{ title: string; body?: string; url?: string } | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const on = (e: Event) => {
      const detail = (e as CustomEvent<{ title: string; body?: string; url?: string }>).detail;
      setEv(detail);
      playChime();
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => setEv(null), SHOW_MS);
    };
    window.addEventListener(CUSTOMER_EVENT, on);
    return () => window.removeEventListener(CUSTOMER_EVENT, on);
  }, []);

  if (!ev) return null;
  const go = () => {
    setEv(null);
    if (ev.url?.startsWith('/app/')) history.push(ev.url);
  };
  return (
    <div role="alert" className="fixed inset-x-0 top-0 z-[2000] p-3 pt-[max(env(safe-area-inset-top),0.75rem)] flex justify-center pointer-events-none">
      <div className="pointer-events-auto w-full max-w-md rounded-2xl bg-brand-black text-white shadow-2xl p-4 flex items-start gap-3 animate-[fadeIn_.15s_ease-out]">
        <span className="size-10 shrink-0 rounded-full bg-brand-red flex items-center justify-center">
          <BellRing className="size-5" aria-hidden />
        </span>
        <button className="flex-1 text-left" onClick={go}>
          <p className="font-bold leading-tight">{ev.title}</p>
          {ev.body && <p className="text-sm text-white/80 mt-0.5 line-clamp-2">{ev.body}</p>}
          {ev.url && <p className="text-xs font-semibold text-brand-red mt-1">Ver detalles →</p>}
        </button>
        <button className="tap size-8 shrink-0 flex items-center justify-center text-white/70" onClick={() => setEv(null)} aria-label="Cerrar">
          <X className="size-4" />
        </button>
      </div>
    </div>
  );
}
